
export function authHeader () {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'))

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token }
    } else {
        return {}
    }
}

export const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js